import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const ScrollAnimation = ({ 
  children, 
  className = "", 
  animation = "fadeInUp",
  delay = 0,
  duration = 0.6,
  threshold = 0.1,
  ...props 
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { 
    once: true, 
    threshold: threshold,
    margin: "-50px 0px -50px 0px"
  });

  const animations = {
    fadeInUp: {
      hidden: { 
        opacity: 0, 
        y: 60,
        scale: 0.95
      },
      visible: { 
        opacity: 1, 
        y: 0,
        scale: 1,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    },
    fadeInLeft: {
      hidden: { 
        opacity: 0, 
        x: -60,
        scale: 0.95
      },
      visible: { 
        opacity: 1, 
        x: 0,
        scale: 1,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    },
    fadeInRight: {
      hidden: { 
        opacity: 0, 
        x: 60,
        scale: 0.95
      },
      visible: { 
        opacity: 1, 
        x: 0,
        scale: 1,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    },
    fadeIn: {
      hidden: { 
        opacity: 0,
        scale: 0.95
      },
      visible: { 
        opacity: 1,
        scale: 1,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    },
    scaleIn: {
      hidden: { 
        opacity: 0,
        scale: 0.8
      },
      visible: { 
        opacity: 1,
        scale: 1,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    },
    slideUp: {
      hidden: { 
        opacity: 0, 
        y: 100
      },
      visible: { 
        opacity: 1, 
        y: 0,
        transition: {
          duration: duration,
          delay: delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }
      }
    }
  };

  const selectedAnimation = animations[animation] || animations.fadeInUp;

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={selectedAnimation}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default ScrollAnimation; 